<div class="row">
  <div class="col">
    <div class="d-flex flex-row align-items-center">
      <a class="btn btn-light ms-3" [routerLink]="['/tenders',tender.id,'locations']" routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: true}">
        Cancel & Return To Locations
      </a>
      <ul class="nav nav-links ms-auto">
        <li class="nav-item" [class.completed]="1 <= stepsCompleted"
          [class.disabled]="isStepDisabled(proposalSteps.INVITATION)">
          <a href="javascript:void(0);" [class.active]="isCurrentLink(proposalSteps.INVITATION)"
            (click)="goToStep(proposalSteps.INVITATION)" class="nav-link">
            Invitation
          </a>
          @if (1 <= stepsCompleted) { <ng-icon name="lucideCircleCheck" class="nav-icon-success"></ng-icon>
            }
        </li>
        <li class="nav-item">
          <div class="nav-step">
            <ng-icon name="lucideChevronRight"></ng-icon>
          </div>
        </li>
        <li class="nav-item" [class.completed]="3 <= stepsCompleted"
          [class.disabled]="isStepDisabled(proposalSteps.SUPPLY_CONDITIONS)">
          <a href="javascript:void(0);" [class.active]="isCurrentLink(proposalSteps.SUPPLY_CONDITIONS)"
            (click)="goToStep(proposalSteps.SUPPLY_CONDITIONS)" class="nav-link">
            Supply Conditions
          </a>
          @if (3 <= stepsCompleted) { <ng-icon name="lucideCircleCheck" class="nav-icon-success"></ng-icon>
            }
        </li>
        <li class="nav-item">
          <div class="nav-step">
            <ng-icon name="lucideChevronRight"></ng-icon>
          </div>
        </li>
        <li class="nav-item" [class.completed]="4 <= stepsCompleted"
          [class.disabled]="isStepDisabled(proposalSteps.BIDS)">
          <a href="javascript:void(0);" [class.active]="isCurrentLink(proposalSteps.BIDS)"
            (click)="goToStep(proposalSteps.BIDS)" class="nav-link">
            Locations
          </a>
          @if (4 <= stepsCompleted) { <ng-icon name="lucideCircleCheck" class="nav-icon-success"></ng-icon>
            }
        </li>
        <li class="nav-item">
          <div class="nav-step">
            <ng-icon name="lucideChevronRight"></ng-icon>
          </div>
        </li>
        <li class="nav-item" [class.completed]="5 <= stepsCompleted"
          [class.disabled]="isStepDisabled(proposalSteps.REVIEW)">
          <a href="javascript:void(0);" [class.active]="isCurrentLink(proposalSteps.REVIEW)"
            (click)="goToStep(proposalSteps.REVIEW)" class="nav-link">
            Submit Submission
          </a>
          @if (5 <= stepsCompleted) { <ng-icon name="lucideCircleCheck" class="nav-icon-success"></ng-icon>
            }
        </li>
      </ul>
    </div>

  </div>
</div>